import InputChips from './InputChips';

export default InputChips;
